import _ from "lodash";
import AppConstants from "../constants/AppConstants";

class MobileBlockLayoutManager {
  constructor(/** Object **/ config = {}) {
    this.layoutWidth = _.get(config, "layoutWidth", AppConstants.LAYOUT_MOBILE_WIDTH);

    this.groupLayoutStrategy = null;
  }

  setGroupLayoutStrategy(/** Object **/ groupLayoutStrategy) {
    this.groupLayoutStrategy = groupLayoutStrategy;
  }

  layout(/** BlockLayout **/ blockLayout) {
    blockLayout.width = this.layoutWidth;
    blockLayout.sortGroups(this._groupSort);
    let groups = blockLayout.groups;

    for (let i = 0; i < groups.length; i++) {
      let group = groups[i];

      this.groupLayoutStrategy.apply(group);

      for (let j = 0; j < group.elements.length; j++) {
        let element = group.elements[j];
        this._layoutElement(blockLayout, group, element);
      }

      blockLayout.height = blockLayout.height + group.height;
    }

    if (!_.isEmpty(blockLayout.backgroundElements)) {
      _.each(blockLayout.backgroundElements, _.partial(this._layoutBackgroundElement, blockLayout));
    }
  }

  /**
   * Sort group bounds by y coords then x
   * @param a
   * @param b
   * @returns {number}
   * @private
   */
  _groupSort(a, b) {
    let boundsA = a.bounds;
    let boundsB = b.bounds;

    if (boundsA.y == boundsB.y) return boundsB.x - boundsB.x;

    return boundsA.y - boundsB.y;
  }

  _layoutElement(
    /** BlockLayout **/ blockLayout,
    /** ElementGroup **/ group,
    /** Object **/ elementData
  ) {
    let localRect = _.get(elementData, "localRect");
    let mobileLayout = _.get(elementData, ["element", AppConstants.LAYOUT_MOBILE]);

    let xDiff = Math.max(0, Math.round((this.layoutWidth - group.width) / 2));

    mobileLayout.y = blockLayout.height + localRect.y;
    mobileLayout.x = localRect.x + xDiff;
    mobileLayout.w = localRect.w;
    mobileLayout.h = localRect.h;

    mobileLayout.a = elementData.a;
  }

  _layoutBackgroundElement(/** BlockLayout **/ blockLayout, /** Object **/ elementData) {
    let mobileLayout = _.get(elementData, ["element", AppConstants.LAYOUT_MOBILE]);

    mobileLayout.y = 0;
    mobileLayout.x = 0;
    mobileLayout.w = blockLayout.width;
    mobileLayout.h = blockLayout.height;

    mobileLayout.a = elementData.a;
  }
}

export default MobileBlockLayoutManager;
